export default "__VITE_ASSET__AXeE63rV__"